var timestamp = Date.now();
/**
 * 生成全局唯一的id
 * @param  {String} [prefix=''] 前缀字符串
 * @return {String}
 *
 * @example
 * guid(); // j7jv509c
 * guid('prefix-'); // prefix-j7jv509d
 */

export default function (prefix) {
  prefix = prefix || '';
  return prefix + (timestamp++).toString(36);
}